import { graphql, useStaticQuery } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

const ImageTeamMember = ({ filename, alt, className, imgClassName }) => {
  const data = useStaticQuery(graphql`
    {
      images: allFile(filter: { relativeDirectory: { eq: "team" } }) {
        edges {
          node {
            relativePath
            name
            childImageSharp {
              gatsbyImageData(width: 600, layout: CONSTRAINED)
            }
          }
        }
      }
    }
  `)
  const image = data.images.edges.find((n) => {
    return n.node.relativePath.includes(filename)
  })
  if (!image) {
    return null
  }

  return (
    <GatsbyImage
      className={className}
      image={image.node.childImageSharp.gatsbyImageData}
      alt={alt}
      imgClassName={imgClassName}
    />
  )
}

export default ImageTeamMember
